/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import { operationTypes } from './ChannelMappingDefType';
import * as Permission from '../util/Permission';

export default declareLinkedEntity({
    entity: "scenarioScreenDefs",
    graphQL: "ScenarioScreenDef",
    name: "Screen Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    defaultTitle: (data) => {
        return data['name'] ? data['name'] : data['key'];
    },
    dynamoPrefix: 'def',
    storageType: 'schema',
    parentRelation: "screenDefs",
    isPublic: true,
    onModify: ['scenarioDef'],
    fields: (types) => { return {
        id: {
            name: "Screen Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            compositeKey: true,
            userEditable: false,
            isPublic: true,
        },
        scenarioDef: {
            name: "Scenario Definition",
            to: () => types['scenarioDefs'],
            type: "relation",
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
            defaultValue: (scenarioDef) => {
                return scenarioDef['id'];
            },
            isPublic: true,
        },
        name: {
            name: "Name",
            type: "string",
            description: "Screen name (you can leave empty).",
            translatable: true,
            defaultValue: "",
            isPublic: true,
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            defaultValue: "",
            isPublic: true,
        },
        key: {
            name: "Key",
            type: "enum",
            description: "Which rule should be used for this screen.",
            required: true,
            isPublic: true,
        },
        entityDef: {
            name: "Entity Definition",
            type: "relation",
            to: () => types['entityDefs'],
            required: true,
            isPublic: true,
            description: "On which Entity page we should show this screen.",
        },
        operation: {
            name: "Operation",
            type: "enum",
            defaultValue: "view",
            values: operationTypes,
            required: true,
            isPublic: true,
        },
        subOperation: {
            name: "Sub operation",
            description: "Sub operation - if user is looking on a detail of item, we can name the sub operation. User can then change the view he is looking on.",
            type: "string",
            defaultValue: "",
            isPublic: true,
        },
        content: {
            name: "Content",
            type: "object",
            defaultValue: {},
            isPublic: true,
        },
        hideInScenario: {
            name: "Hide in scenario",
            type: "boolean",
            defaultValue: false,
            isPublic: true,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
        views: {
            type: 'oneToMany',
            to: types['views'],
            hasPaging: false,
            export: true,
            defaultValue: () => {
                return {};
            },
            isPublic: true,
        },
        dataSources: {
            type: 'oneToMany',
            to: types['dataSources'],
            hasPaging: false,
            export: true,
            defaultValue: () => {
                return {};
            },
            isPublic: true,
        },
    }; }
});
